import { render } from "./SamTarea.vue?vue&type=template&id=04cf44d6"
import script from "./SamTarea.vue?vue&type=script&lang=js"
export * from "./SamTarea.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__